import { useNotifyStore } from '~/store'

export default defineNuxtPlugin(nuxtApp => {
    nuxtApp.provide('showToaster', toaster => {
        const notifyStore = useNotifyStore()
        notifyStore.showMessage(toaster)
    })
})